import React from 'react'
import UserDetail from '../../admin/UserDetail'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3UserDetailPage() {
  return (
    <V3DataRouteShell>
      <UserDetail visualVariant="v3" />
    </V3DataRouteShell>
  )
}

